// @ts-nocheck
export const SET_CURRENT_SESSION = 'SET_CURRENT_SESSION';

export const setCurrentSession = session => {
  return {
    data: { session },
    type: SET_CURRENT_SESSION
  };
};
